import React, {  } from 'react'
import { css, StyleSheet } from 'aphrodite';
import { Grid } from '@material-ui/core';

import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppTheme } from '../../styles/AppTheme';
import { Helper } from '../../common/helpers/Helper';
import { SubEntityCard } from '../../common/components/SubEntity/SubEntityCard';
import { AppHelper } from '../../helpers/AppHelper';

export class SettingsMaster extends BaseEntityPage {
  constructor(props) {
    super(props)
    this.pageTitle = Helper.getString('settingsMaster')
    this.pageKey = 'settingsMaster'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.emptyText = ' ' // space
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.groupId = 'settings' + this.orgId
    this.toFetch = [
      {
        key: 'settingscita',
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['items', 'settingscita-all'], {
          groupId: 'settingscita',
          pb: 'fieldDefSettingsCita'
        })
      },
      {
        key: 'settingsmag',
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['items', 'settingsmag-all'], {
          groupId: 'settingsmag',
          pb: 'fieldDefSettingsMag'
        })
      },
      {
        key: 'settingsActiveExchange',
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['items', 'settingexchange-all'], {
          groupId: 'settingexchange',
          pb: 'fieldDefSettingsActiveExchange'
        })
      },
      {
        key: 'settingsHistory',
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['items'], {
          groupId: 'mastersettinghistory',
          limit: 1000
        })
      }
    ]
    this.tableHeadersMap = {
      Time: (current) => AppHelper.formatTimestamp(current.createdTs || current.ts),
      Who: (current) => current.userEmail || current.userId || '',
      Setting: (current) => current.settingLabel || current.settingId || '',
      Action: (current) => <div className={css(Styles.historyChanges)}><div>{current.comment || current.action || ''}</div><div>{current.changes || ''}</div></div>
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.noAdd = true
    this.apiData = {}
  }

  getExchangeOptions = (settingsActiveExchange) => {
    const rawOptions = settingsActiveExchange && settingsActiveExchange.exchangeOptions
    if (!rawOptions) return []

    let options = rawOptions
    if (typeof rawOptions === 'string') {
      try {
        options = JSON.parse(rawOptions)
      } catch (err) {
        return []
      }
    }

    if (!Array.isArray(options)) return []

    return options.map((item) => {
      const value = typeof item === 'string' ? item : item && item.key
      if (!value) return null
      return {
        key: value,
        label: item.value,
        text: item.value
      }
    }).filter(Boolean)
  }

  onFetchSuccess(results, options = {}) {
    const { fetchNext = false } = options
    console.log('onFetchSuccess:', results)
    if (!fetchNext) {
      this.settingscita = this.getResult(results, 'settingscita')
      this.fieldDefSettingsCita = this.settingscita.fieldDefSettingsCita
      this.settingsmag = this.getResult(results, 'settingsmag')
      this.fieldDefSettingsMag = this.settingsmag.fieldDefSettingsMag
      this.settingsActiveExchange = this.getResult(results, 'settingsActiveExchange')
      this.fieldDefSettingsActiveExchange = this.settingsActiveExchange.fieldDefSettingsActiveExchange
      // Prefill dynamic options
      const activeExchangeField = this.fieldDefSettingsActiveExchange
        && this.fieldDefSettingsActiveExchange.steps
        && this.fieldDefSettingsActiveExchange.steps[0]
        && this.fieldDefSettingsActiveExchange.steps[0].fields
        && this.fieldDefSettingsActiveExchange.steps[0].fields.find((field) => field.key === 'activeExchanges')
      if (activeExchangeField) {
        activeExchangeField.options = this.getExchangeOptions(this.settingsActiveExchange)
      }
      this.settingsHistory = this.getResult(results, 'settingsHistory') || { items: [] }
    } else {
      this.settingsHistory = results[0] || { items: [] }
    }
    // Pagination on history table
    this.handleNextpage(this.settingsHistory)
    this.toFetchNext = {
      method: 'GET',
      paths: ['items'],
      queryParams: {
        groupId: 'mastersettinghistory',
        limit: 1000
      }
    }
    if (this.settingsHistory.nextPage) {
      this.toFetchNext.queryParams = {
        groupId: 'mastersettinghistory',
        nextPage: this.settingsHistory.nextPage,
        limit: 1000
      }
    }
    this.setState((prevState) => ({
      items: fetchNext ? prevState.items.concat(this.settingsHistory.items || []) : (this.settingsHistory.items || [])
    }))
  }

  renderAboveTable() {
    const settingsCitaCount = Object.keys((this.settingscita && this.settingscita.items) || {}).length
    const settingsMagCount = Object.keys((this.settingsmag && this.settingsmag.items) || {}).length
    const activeExchangeCount = ((this.settingsActiveExchange && this.settingsActiveExchange.activeExchanges) || []).length

    return (
      <div className={css(Styles.containerNarrow)}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <SubEntityCard
              title={'Citadel - ' + settingsCitaCount + ' Screens onboarded'}
              formDefinition={this.fieldDefSettingsCita}
              item={this.settingscita || {}}
              openModalForEdit={(current) =>
                this.openModalForEdit(current, this.fieldDefSettingsCita)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SubEntityCard
              title={'Magnite - ' + settingsMagCount + ' Screens onboarded'}
              formDefinition={this.fieldDefSettingsMag}
              item={this.settingsmag || {}}
              openModalForEdit={(current) =>
                this.openModalForEdit(current, this.fieldDefSettingsMag)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SubEntityCard
              title={'Exchange Settings - ' + activeExchangeCount + ' Active'}
              formDefinition={this.fieldDefSettingsActiveExchange}
              item={this.settingsActiveExchange || {}}
              openModalForEdit={(current) =>
                this.openModalForEdit(current, this.fieldDefSettingsActiveExchange)}
            />
          </Grid>
        </Grid>
        <div className={css(Styles.historyHeading)}>Settings History</div>
      </div>
    );
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions() {
    return []
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: current.groupId }),
    })
  }

  // openModalForEdit(current, formDefinition, attrName) {
  //   this.attrName = attrName
  //   this.formDefinition = formDefinition
  //   this.formDefinition.formType = 'edit'
  //   Helper.populateFormDefinitionValues(this.formDefinition, current)
  //   this.setState({ modalOpen: true })
  // }

  // customSubmit(options) {
  //   const { formType, formData } = options
  //   console.log('customSubmit:', formData)
  //   ApiHelper.call({
  //     method: 'PUT', paths: ['items', this.groupId + '-all'], queryParams: { groupId: this.groupId },
  //     jsonBody: { [this.attrName]: { ...formData } }
  //   },
  //   (err, data) => {
  //     if (err) {
  //       const errorMessage = Helper.getErrorMsg(err)
  //       this.setState({
  //         fetchState: ApiHelper.State.ERROR,
  //         errMsg: errorMessage,
  //         success: false,
  //         message: errorMessage,
  //         inProcess: false
  //       })
  //       return
  //     } else {
  //       this.setState({ modalOpen: false })
  //       this.fetchItems()
  //     }
  //   })
  // }
}

const Styles = StyleSheet.create({
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: AppTheme.viewPort,
    // paddingBottom: 50,
    width: '100%',
    '@media (max-width: 767px)': {//TODO: next?
      //width: window.innerWidth - 20 //TODO: fix it, in product screen whitespace nowrap creating issue
    },
  },
  container: {
    textAlign: 'center',
    maxWidth: AppTheme.viewPort,
    marginBottom: 20,
    width: '100%',
  },
  historyHeading: {
    width: '100%',
    marginTop: 38,
    marginBottom: 12,
    fontSize: 24,
    fontWeight: 600,
    textAlign: 'left',
    color: '#111827',
  },
  historyChanges: {
    whiteSpace: 'pre-line',
    maxWidth: 420,
  }
})



// WEBPACK FOOTER //
// ./src/screens/admin/SettingsMaster.js